import React from 'react';
import { FormControl, InputLabel, Select, TextField } from '@material-ui/core';
import { LOCATION_INFO_OPTIONS, LOCATION_TYPES } from './constants';
import { Fieldset } from './blocks';

/**
 * Location type, its dependent pickup-detail select, and the QBO class. Identical in both forms.
 *
 * When no type is chosen the detail select still renders — disabled, showing the Residence
 * options — so the row does not reflow once a type is picked. That is what the old panel did.
 */
const LocationTypeFields = ({ chosen, hasError, viewOnly, patch }) => {
    const type = chosen.location_type;
    const infoOptions = LOCATION_INFO_OPTIONS[type] || LOCATION_INFO_OPTIONS.Residence;

    return (
        <Fieldset columns={3}>
            <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="location-type">Location type</InputLabel>
                <Select
                    native
                    inputProps={{ id: 'location-type' }}
                    label="Location type"
                    value={type || ''}
                    disabled={viewOnly}
                    error={hasError.location_type}
                    onChange={(e) => patch({ location_type: e.target.value })}
                >
                    <option aria-label="None" value="" />
                    {LOCATION_TYPES.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Select>
            </FormControl>

            <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="location-info">Location details</InputLabel>
                <Select
                    native
                    inputProps={{ id: 'location-info' }}
                    label="Location details"
                    value={chosen.location_info || ''}
                    disabled={!type || viewOnly}
                    error={hasError.location_info}
                    onChange={(e) => patch({ location_info: e.target.value })}
                >
                    <option aria-label="None" value="" />
                    {infoOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Select>
            </FormControl>

            <TextField
                fullWidth
                variant="outlined"
                id="location-qbo-class"
                label="QBO Class"
                value={chosen.qbo_class || ''}
                disabled={viewOnly}
                onChange={(e) => patch({ qbo_class: e.target.value })}
            />
        </Fieldset>
    );
};

export default LocationTypeFields;
